import React, { useState } from "react";
import { format, parseISO } from "date-fns";
import copy from "copy-to-clipboard";

const PublishTab = ({ episode, setEpisode }) => {
  const [copied, setCopied] = useState(false);

  const {
    prompt,
    promptSource,
    sponsor,
    sponsorDescription,
    answer,
    date,
  } = episode;

  const title = prompt;
  const publishingDate = format(parseISO(date), "MMMM d, yyyy"); // "March 12, 2020 4:20 AM"
  const episodeSummary = answer;
  const showNotes = `On today's episode of Your Thoughts, you think about the answer to the
        question: ${prompt} ${
    promptSource ? `from ${promptSource}` : ""
  }<br><br>Today's episode is sponsored by
        ${sponsorDescription}<br><br>To share what you thought on today's episode or to send in a
        suggested prompt, visit <a href="https://yourthoughts.fm">YourThoughts.fm</a>.`;

  // setInput("episode_description", \`${showNotes}\`);
  const javascript = `
    if(document.location.pathname.includes("/edit")){
      document.location = "/shows/your-thoughts/episodes/new"
    }else{
      function setInput(id, value){
        input = document.getElementById(id);
        input.value = value;
      }
      setInput("episode_title", \`${title}\`);

      setInput("episode_summary", \`${episodeSummary}\`);

      $("#episode_published_at_date").datepicker.setDate("${publishingDate}");

      document.querySelector("[input='episode_description']").editor.loadHTML(\`${showNotes}\`);

      setInterval(() => {
        const uploadedSpan = document.querySelector("[x-show='uploaded']");
        if(uploadedSpan && uploadedSpan.style.display !== "none"){
          document.querySelector("form button.button").click();
        }
      }, 1000);
    }
  `.replace(/\n/g, "");
  const bookmarklet = `(function(){${javascript}})();`;
  return (
    <div>
      <pre className="bg-gray-300 rounded mb-6 p-4 overflow-scroll">
        ffmpeg -i ~/Downloads/{date}.mp3 ~/Desktop/Your\ Thoughts/{date}.mp3
      </pre>
      <p>Or, if I sound low pitched:</p>
      <pre className="bg-gray-300 rounded mb-6 p-4 overflow-scroll">
        ffmpeg -i ~/Downloads/{date}.mp3 -af asetrate=48000,aresample=44100
        ~/Desktop/Your\ Thoughts/{date}.mp3
      </pre>
      <p>Or, if I sound HIGH pitched:</p>
      <pre className="bg-gray-300 rounded mb-6 p-4 overflow-scroll">
        ffmpeg -i ~/Downloads/{date}.mp3 -af asetrate=44100,aresample=48000
        ~/Desktop/Your\ Thoughts/{date}.mp3
      </pre>
      <button
        className={`${
          copied ? "" : "bg-green-500 hover:bg-green-700 text-white"
        } font-bold py-2 px-4 rounded w-full`}
        onClick={() => {
          copy(bookmarklet);
          setCopied(true);
          setTimeout(() => {
            // setCopied(false);
          }, 1000);
        }}
      >
        {!copied && "📋 Copy Javascript"}
        {copied && "✅Copied!"}
      </button>
    </div>
  );
};

export default PublishTab;
